<template>
    <Login @authenticated="onAuth" />
</template>

<script setup>
import Login from "../components/auth/Login.vue";
import { useRouter } from "vue-router";

const router = useRouter();

const onAuth = () => {
    router.replace({ name: "formular" });
};
</script>